export class PerfilPlanoParticipante {
    iD_PESSOA: number;
    iD_PLANO: number;
    dT_VIGENCIA: Date;
    iD_PERFIL: number;
    nM_ERRO: string;
    iC_VALIDO: boolean;
}